import childEditionPreviousEdition from '@/services/http/api/childEditionPreviousEdition'
import permissions from '@/constants/permissions'
import { FetchPeselPayloadSchema } from '@/schemas/childEdition'

export default {
  namespaced: true,
  state: {
    loader: null,
    child: null,
    resources: null,
    childDataRequestSkipped: false,
    childPesel: null
  },
  getters: {
    getLoader: (state) => state.loader,
    getChild: (state) => state.child,
    getResources: (state) => state.resources,
    getChildEditionName: (state) => state?.child?.edition?.name || null,
    getChildDataRequestSkipped: (state) => state.childDataRequestSkipped,
    getChildPesel: (state) => state.childPesel,
    hasViewPeselPastEditionPermission: (state, getters, rootState, rootGetters) =>
      rootGetters['auth/userHasPermission'](permissions.peselViewPastEdition)
  },
  mutations: {
    setLoader(state, payload) {
      state.loader = payload
    },
    setChild(state, payload) {
      state.child = payload
    },
    setResources(state, payload) {
      state.resources = payload
    },
    clear(state) {
      state.loader = null
      state.child = null
      state.resources = null
    },
    setChildDataRequestSkipped(state, payload) {
      state.childDataRequestSkipped = payload
    },
    setChildPesel(state, payload) {
      state.childPesel = payload
    }
  },
  actions: {
    async getChildData({ commit, dispatch }, payload) {
      if (Number.isInteger(Number(payload?.childEditionId)) === false) {
        const error = new Error('invalid child edition id')
        error.response = { status: 404 }
        return Promise.reject(error)
      }
      commit('setLoader', true)

      return childEditionPreviousEdition
        .get(payload, payload?.getAssignedFirst)
        .then(({ data }) => {
          commit('setChild', data?.data?.child_edition || null)
          let resources = null
          if (data?.data?.resources) {
            resources = {
              ...data.data.resources
            }
            if (resources?.document_questions?.guardian_consent) {
              resources.document_questions.guardian_consent = {
                ...resources.document_questions.guardian_consent,
                is_street_disabled: {
                  // @TODO: add useI18n composable translation in Pinia
                  label: 'Miejscowość nie posiada ulic',
                  required: false
                }
              }
            }
          }
          commit('setResources', resources)
          return data.data
        })
        .catch((error) => {
          if (
            error?.response?.status === 403 &&
            payload?.getAssignedFlag &&
            !payload?.getAssignedFirst
          ) {
            dispatch('getChildData', { ...payload, getAssignedFirst: true })
          } else throw error
        })
        .finally(() => {
          commit('setLoader', false)
        })
    },
    async fetchPesel({ commit, getters }, childEditionId) {
      if (!getters.hasViewPeselPastEditionPermission) {
        console.warn('User does not have permission to view pesel')
        return
      }

      commit('setLoader', true)

      const payloadValidation = FetchPeselPayloadSchema.safeParse({ childEditionId })
      if (!payloadValidation.success) {
        console.error('[fetchPesel] Zod Validation Eerror', payloadValidation.error.format())
        return
      }

      try {
        const peselResponse = await childEditionPreviousEdition.getPesel(childEditionId)
        const { pesel } = peselResponse.data.data
        commit('setChildPesel', pesel)
      } catch (error) {
        console.error('Failed to fetch pesel', error)
      } finally {
        commit('setLoader', false)
      }
    }
  }
}
